/* eslint-disable @typescript-eslint/no-explicit-any */
import { AR_LOCALE, HI_LOCALE, TH_LOCALE, RU_LOCALE, ES_LOCALE } from '../store/ngDatepickerConstants';

export const getLocaleFromDocument = (): string => {
  if (typeof document === 'undefined') return '';
  return document.documentElement?.lang;
};

export const getPageDirectionFromDocument = (): string => {
  if (typeof document === 'undefined') return '';
  return document.documentElement?.dir;
};

const convertArabicToEnglishNumbers = (str: string): string => {
  return str.replace(/[\u0660-\u0669]/g, c => String(c.charCodeAt(0) - 0x0660));
};

const convertHindiToEnglishNumbers = (str: string): string => {
  return str.replace(/[\u0966-\u096F]/g, c => String(c.charCodeAt(0) - 0x0966));
};

export const formatDateStringBasedOnLocale = (dateString: string): string => {
  const locale = getLocaleFromDocument();
  if (locale === AR_LOCALE) return convertArabicToEnglishNumbers(dateString);
  if (locale === HI_LOCALE) return convertHindiToEnglishNumbers(dateString);
  return dateString;
};

export const checkLocaleToAddYears = (currentLocale: string, year: number): number => {
  if (currentLocale === TH_LOCALE) return Number(year + 543);
  return year;
};

export const modifyDateStringForThai = (dateString: string): string => {
  let modifiedDateString = '';
  let i = 0;
  while (i < dateString.length) {
    if (dateString[i] >= '0' && dateString[i] <= '9') {
      const start = i;
      const end = i + 3;
      if (end < dateString.length && dateString[end] >= '0' && dateString[end] <= '9') {
        const numericDigits = dateString.slice(start, end + 1);
        const convertedYear = parseInt(numericDigits) - 543;
        modifiedDateString += convertedYear.toString();
        i = end + 1;
      } else {
        modifiedDateString += dateString[i];
        i++;
      }
    } else {
      modifiedDateString += dateString[i];
      i++;
    }
  }
  return modifiedDateString;
};

export const convertToUpperCase = (text: string, locale: string): string => {
  if (locale === RU_LOCALE) return text?.toLocaleUpperCase();
  if (locale === ES_LOCALE) return text ? text.charAt(0).toUpperCase() + text.slice(1) : text;
  return text;
};

/* eslint-disable @typescript-eslint/no-explicit-any */
export async function updateSessionInSearchForm(
  sessionData?: any,
  sessionUrl?: string,
  prefix?: string,
  singleDateLimit?: any,
  groupDateLimit?: any,
  sessionToken?: string
): Promise<void> {
  try {
    const params = { sessionData, sessionUrl, prefix, singleDateLimit, groupDateLimit, sessionToken };
    const response = await fetch('/search/search-availability', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    });
    if (!response.ok) throw new Error('Session update failed');
  } catch (error) {
    console.warn('updateSessionInSearchForm failed:', error);
  }
}

export const capitalize = (text: string) => {
  return `${text?.charAt(0)?.toUpperCase()}${text?.slice(1)?.toLowerCase()}`;
};
